export default [
  { abbr: 'pp', id: 'BOOK_818b3907cd4947e6ba2a3170e4df2856' },
  { abbr: 'hr', id: 'BOOK_f9661d9af5764404a8d21233467511b1' },
  { abbr: 'bo', id: 'BOOK_M8vwoV4NQPWELETLrBK8Yg' },
  { abbr: 'mg', id: 'BOOK_pPg9ABaPSj2mL6qoMTKR1A' },
  { abbr: 'tb', id: 'BOOK_b3fee420f26241918245bf07a254f992' },
  { abbr: 'ca', id: 'BOOK_IPBQaQQTCRxplZx7SYOA' },
  { abbr: 'dk', id: 'BOOK_nhLZ9l5DRs6w6KcE2n7vnw' },
  { abbr: 'tf', id: 'BOOK_288fb70dc7aa4e50868a7e2a968803a0' },
  { abbr: 'fl', id: 'BOOK_79f420f246df4e2a8907373413eee3a5' },
  { abbr: 'fd', id: 'BOOK_Rf7xRhS7TKQUl94Xkt5w' },
  { abbr: 'pe', id: 'BOOK_0486650204584a98b585a05f5bfaaeee' },
  { abbr: 'sl', id: 'BOOK_831307ef9710497aa6fc5544eb7fe528' },
  { abbr: 'bf', id: 'BOOK_a264fc209850488d957d9d465e3195c7' },
  { abbr: 'bs', id: 'BOOK_c81242f993894e67966b3ccfc4ba3a65' },
  { abbr: 'pb', id: 'BOOK_yQb2mAZpRGGCqPSYu4hmmg' },
  { abbr: 'br', id: 'BOOK_88064cc6787c47ccbd4bbb036c7f55c5' },
  { abbr: 'ud', id: 'BOOK_1aac80eb006640bd9722eb25ae73845a' },
  { abbr: 'st', id: 'BOOK_74a5f65d2d5c48c3952f94f7dd758f63' },
  { abbr: 'sh', id: 'BOOK_b3865cc1a43347c4ae54863a243ed187' },
  { abbr: 'wb', id: 'BOOK_cba8e90df3a9452a82c687e39afa6136' },
  { abbr: 'fb', id: 'BOOK_YYX0syInRfa4FmU09xLg' }
];